/* Scented Breeze: scent tabs, sticky bar, offer anchor. No dependencies. */
(function () {
  // scent tabs (WAI-ARIA tabs with arrow keys)
  document.querySelectorAll('.sb [role="tablist"]').forEach(function (list) {
    var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
    function select(tab) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) {
        var k = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!k) return;
        var n = tabs[(i + k + tabs.length) % tabs.length]; select(n); n.focus(); e.preventDefault();
      });
    });
  });

  // offer anchor: land on the buy box (re-aim once fonts/images settle)
  var anchor = document.getElementById('sb-offer');
  document.querySelectorAll('.sb a[href="#sb-offer"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (!anchor) return;
      e.preventDefault();
      var tries = 0;
      (function go() {
        var y = anchor.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({ top: y, behavior: tries ? 'auto' : 'smooth' });
        if (++tries < 6) setTimeout(go, 300);
      })();
    });
  });

  // sticky bar: show after the hero, hide while the offer is on screen
  var bar = document.getElementById('sb-sticky');
  var hero = document.getElementById('sb-hero');
  if (bar && hero && 'IntersectionObserver' in window) {
    var heroOut = false, offerIn = false;
    var offer = anchor && anchor.nextElementSibling ? anchor : null;
    function paint() {
      var on = heroOut && !offerIn;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      var b = bar.querySelector('a'); if (b) b.tabIndex = on ? 0 : -1;
    }
    new IntersectionObserver(function (es) { heroOut = !es[0].isIntersecting; paint(); }, { threshold: 0 }).observe(hero);
    // the buy box sits right after the anchor; watch the anchor's next real block
    var buy = document.getElementById('sb-buy');
    if (buy) new IntersectionObserver(function (es) { offerIn = es[0].isIntersecting; paint(); }, { threshold: 0, rootMargin: '-80px 0px -80px 0px' }).observe(buy);
  }
})();

/* inline videos: load and play only near the viewport (poster shows until then); pause off-screen; reduced motion = poster + controls */
(function () {
  var vids = document.querySelectorAll('.sb video[data-sb-video]');
  if (!vids.length) return;
  var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function load(v) { if (!v.src) { v.src = v.getAttribute('data-sb-video'); } }
  vids.forEach(function (v) {
    v.muted = true;
    if (still) { v.controls = true; v.preload = 'none'; v.addEventListener('play', function () { load(v); }, { once: true }); return; }
    if (!('IntersectionObserver' in window)) { load(v); v.play().catch(function () {}); return; }
    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { load(v); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else if (v.src) v.pause();
      });
    }, { rootMargin: '300px 0px' }).observe(v);
  });
})();

/* endless swipe (phones): rows marked data-loop wrap from the last card back to the first, both ways */
(function () {
  var mq = window.matchMedia('(max-width: 768px)');
  document.querySelectorAll('.sb .swipe[data-loop]').forEach(function (track) {
    var real = [].slice.call(track.children), n = real.length, on = false, timer;
    if (n < 2) return;
    function clone(el) { var c = el.cloneNode(true); c.classList.add('is-clone'); c.setAttribute('aria-hidden', 'true'); c.setAttribute('inert', ''); c.querySelectorAll('a,button,[tabindex]').forEach(function (x) { x.setAttribute('tabindex', '-1'); }); return c; }
    function pad() { return parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0; }
    function start() { return real[0].offsetLeft - pad(); }
    function setW() { return track.querySelector('.is-clone.after').offsetLeft - real[0].offsetLeft; }
    function jump(x) { var s = track.style.scrollSnapType; track.style.scrollSnapType = 'none'; track.scrollLeft = x; void track.offsetWidth; track.style.scrollSnapType = s; }
    function fix() {
      if (!on) return;
      var x = track.scrollLeft, a = start(), w = setW();
      if (x < a - 4) jump(x + w); else if (x >= a + w - 4) jump(x - w);
    }
    function setup() {
      if (on || !mq.matches) return;
      real.forEach(function (el) { var c = clone(el); c.classList.add('after'); track.appendChild(c); });
      for (var i = n - 1; i >= 0; i--) { var c = clone(real[i]); c.classList.add('before'); track.insertBefore(c, track.firstChild); }
      on = true; jump(start());
    }
    function teardown() { if (!on) return; track.querySelectorAll('.is-clone').forEach(function (c) { c.remove(); }); on = false; }
    track.addEventListener('scroll', function () { clearTimeout(timer); timer = setTimeout(fix, 140); }, { passive: true });
    if ('onscrollend' in window) track.addEventListener('scrollend', fix);
    (mq.addEventListener ? mq.addEventListener('change', function () { mq.matches ? setup() : teardown(); }) : mq.addListener(function () { mq.matches ? setup() : teardown(); }));
    if (document.readyState === 'complete') setup(); else window.addEventListener('load', setup);
  });
})();

/* nursery: reviews on phones drift slowly on their own; a touch pauses them, they resume 2.5s after; loops via the data-loop clones */
(function () {
  var t = document.querySelector('.sb .rvs[data-loop]');
  if (!t || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var mq = window.matchMedia('(max-width: 768px)'), SPEED = 28, held = false, resumeAt = 0, inView = false, pos = null, last = 0;
  function span() {
    var real = [].slice.call(t.children).filter(function (c) { return !c.classList.contains('is-clone'); });
    var after = t.querySelector('.is-clone.after');
    if (!real.length || !after) return null;
    var pad = parseFloat(getComputedStyle(t).scrollPaddingLeft) || 0;
    return { a: real[0].offsetLeft - pad, w: after.offsetLeft - real[0].offsetLeft };
  }
  function hold() { held = true; t.style.scrollSnapType = ''; }
  function release() { held = false; resumeAt = performance.now() + 2500; pos = null; }
  t.addEventListener('touchstart', hold, { passive: true });
  t.addEventListener('pointerdown', hold);
  t.addEventListener('touchend', release, { passive: true });
  t.addEventListener('pointerup', release);
  t.addEventListener('touchcancel', release, { passive: true });
  if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { inView = es[0].isIntersecting; }).observe(t); else inView = true;
  function tick(now) {
    var dt = last ? Math.min(now - last, 64) : 16; last = now;
    if (mq.matches && inView && !held && now >= resumeAt && !document.hidden) {
      var s = span();
      if (s) {
        if (pos === null) pos = t.scrollLeft;
        t.style.scrollSnapType = 'none';
        pos += SPEED * dt / 1000;
        if (pos >= s.a + s.w) pos -= s.w;
        t.scrollLeft = Math.round(pos);
      }
    } else if (!held && now < resumeAt) { t.style.scrollSnapType = ''; }
    requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);
})();

/* nursery: desktop "read all reviews" toggle */
(function () {
  var b = document.querySelector('.sb [data-rv-more]'), g = document.querySelector('.sb [data-rv]');
  if (!b || !g) return;
  b.addEventListener('click', function () { var on = !g.classList.contains('is-all'); g.classList.toggle('is-all', on); b.setAttribute('aria-expanded', on ? 'true' : 'false'); b.textContent = on ? 'Show fewer reviews' : b.getAttribute('data-label'); });
  b.setAttribute('data-label', b.textContent);
})();

(function(){var w=document.querySelector('.sb .rvm');if(!w)return;function on(){w.classList.add('is-paused')}function off(){w.classList.remove('is-paused')}w.addEventListener('pointerdown',on);w.addEventListener('pointerup',off);w.addEventListener('pointercancel',off);w.addEventListener('pointerleave',off);})();
